import ListCellName from "./ListCellName";
import ListCellOrg from "./ListCellOrg";

const ListViewName = ({ users, removable, type, onDelete, icon_name }) => {
  return (
    <div className="flex flex-col w-full rounded-md  overflow-auto shadow-md justify-center">
      {/* Conditional rendering based on the users array */}
      {users === null ||
      users.length === 0 ||
      (users.length === 1 && !users[0]) ? (
        <div className="text-h3 text-shadow_50">Pas de personne assigné</div>
      ) : type == "user" ? (
        users.map((user, index) => (
          <div key={index}>
            <ListCellName
              key={user?.id}
              user={user}
              removable={removable}
              onDelete={onDelete}
              icon_name={icon_name}
            />
          </div>
        ))
      ) : (
        users.map((org, index) => (
          <div key={index}>
            <ListCellOrg
              key={org?.id}
              org={org}
              removable={removable}
              onDelete={onDelete}
              icon_name={icon_name}
            />
          </div>
        ))
      )}
    </div>
  );
};

export default ListViewName;
